export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
export const toggleSideNav = () => ({
  type: TOGGLE_SIDE_NAV,
  payload: {},
});
